/**
 * 认证相关API URL
 */
import { API_BASE_URL, API_VERSION, API_MODULES } from '../config';

const BASE_URL = `${API_BASE_URL}${API_MODULES.USER_SVC}`;

export default {
  //获取验证码
  GET_CAPTCHA: `${BASE_URL}/api${API_VERSION.V2}/kaptcha`,
  // 登录相关
  LOGIN: `${BASE_URL}/api${API_VERSION.V1}/login`,
  //发送短信验证码
  SEND_SMS_CODE: `${BASE_URL}/api/1.5/regMsg`,

  //发送短信验证码 - 注册
  SEND_SMS_CODE_REGISTER: `${BASE_URL}/api${API_VERSION.V2}/_bai/registerAndLogin/regMsg`,

  //注册加登录 
  REGISTER_LOGIN: `${BASE_URL}/api${API_VERSION.V1}/registerAndLogin`,

  //修改个人信息 
  REGISTER_INFO: `${BASE_URL}/api${API_VERSION.V1}/personal_user_authen_info`,
}; 